<template>
    <b-modal id="NewTicket" title="Create ticket" :hide-footer="true">
        <b-form>
            <b-form-group>
                <label for="newTicketSubject">Subject</label>
                <b-form-input
                    id="newTicketSubject"
                    type="text"
                    v-model="ticket.subject"
                    placeholder
                />
            </b-form-group>

            <b-form-group>
                <label for="ticketDescription">Description</label>
                <b-form-textarea
                    id="ticketDescription"
                    placeholder="Write a description for your inquiry"
                    :rows="5"
                    v-model="ticket.description"
                />
            </b-form-group>

            <spinner v-if="saving" />
            <b-form-group v-if="!saving">
                <b-btn variant="primary" @click="onSubmit">Save</b-btn>
            </b-form-group>
            <div v-if="errors.length">
                <b>Please correct the following error(s):</b>
                <ul>
                    <li v-for="e in errors" :key="e.id">{{ e.description }}</li>
                </ul>
            </div>
        </b-form>
    </b-modal>
</template>

<script>
export default {
    name: 'new-ticket-modal',
    data() {
        return {
            errors: [],
            saving: false,
            ticket: this.getDefaultTicket(),
            okText: 'Create ticket',
        }
    },

    created() {
        // console.log('INSTANCE', this)
    },

    methods: {
        guid() {
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (
                    c ^
                    (crypto.getRandomValues(new Uint8Array(1))[0] &
                        (15 >> (c / 4)))
                ).toString(16)
            )
        },
        getDefaultTicket() {
            return {
                subject: null,
                description: null,
            }
        },
        validForm() {
            // console.log('newTicket', this.ticket)
            if (this.ticket.subject && this.ticket.description) {
                return true
            }

            this.errors = []

            if (!this.ticket.subject) {
                this.errors.push(this.createError('Subject required.'))
            }
            if (!this.ticket.description) {
                this.errors.push(this.createError('Description required.'))
            }

            return this.errors.length <= 0
        },
        createError(error) {
            return { id: this.guid(), description: error }
        },

        onSubmit() {
            if (!this.validForm()) {
                return
            }
            this.saving = true
            this.$http
                .post('/services/tickets', this.ticket)
                .then(res => res.data)
                .then(ticket => {
                    this.$emit('ticketCreated', ticket)
                    this.ticket = this.getDefaultTicket()
                })
                .catch(err => {
                    this.errors.push(this.createError(err))
                })
                .finally(() => {
                    this.saving = false
                })
        },

        onCancel() {
            this.visible = false
        },
    },
}
</script>

<style></style>
